import { parseQueryString } from "@grindex-client/common/js/helpers/query-parser";

const SELECTOR_TRACKING_ATTRIBUTE = "xyl-hittrackingid";
const SELECTOR_TRACKING = "a[xyl-hittrackingid]";

export default class SearchTracker {
	constructor(getQuery) {
		this.getQuery = getQuery;
	}

	bindTrackingEvent() {
		const $trackingAnchorLinks = document.querySelectorAll(SELECTOR_TRACKING);

		$trackingAnchorLinks.forEach(($anchor) => {
			$anchor.addEventListener(
				"click",
				function (e) {
					this.registerTrackClick(e.currentTarget.getAttribute(SELECTOR_TRACKING_ATTRIBUTE));
				}.bind(this),
				{ once: true },
			);
		});
	}

	registerTrackClick(hitId) {
		const query = this.getQuery();
		const data = {
			query: query.query,
			hitId: hitId,
			trackId: window.config.search.trackId,
		};

		fetch(window.config.search.searchTrackingApiUrl + parseQueryString(data), {
			method: "GET",
		});
	}
}
